export const QUESTION_TYPES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  INFO: 'info',
} as const;

export const MESSAGE_SENDERS = {
  USER: 'user',
  SYSTEM: 'system',
} as const;

export type OptionType = {
  id: string;
  text: string;
  value: string;
};

export type AnswerType =
  string | string[] | { answer: string | string[]; textInput?: string } | null;

export type QuestionType = {
  id: string;
  text: string;
  type: (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];
  options?: OptionType[];
  nextQuestion?: string | ((answer: AnswerType) => string);
  hasTextInput?: boolean;
  textInputLabel?: string;
};

export type MessageType = {
  id: string;
  sender: (typeof MESSAGE_SENDERS)[keyof typeof MESSAGE_SENDERS];
  content: string;
  type: (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];
  options?: OptionType[];
  questionId?: string;
  hasTextInput?: boolean;
  textInputLabel?: string;
};

export type SapaMessageItemType = MessageType & {
  options?: OptionType[];
  questionId?: string;
  hasTextInput?: boolean;
  textInputLabel?: string;
};
